import { PointLightItem } from './Point';
import { DirectionalLightItem } from './Directional';
import { AmbientLightItem } from './Ambient';
import { SpotLightItem } from './Spot';
import { HemisphereLightItem } from './Hemisphere';

export const LightDefinitions = {
  'light.point': PointLightItem,
  'light.directional': DirectionalLightItem,
  'light.ambient': AmbientLightItem,
  'light.spot': SpotLightItem,
  'light.hemisphere': HemisphereLightItem,
};